import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketSeclectSectionAC } from './AC/BasketSeclectSection.AC';
import { BasketSeclectSectionOV } from './OV/BasketSeclectSection.OV';
import { BasketSeclectSectionAP } from './AP/BasketSeclectSection.AP';
import { BasketSeclectSectionDS } from './DS/BasketSeclectSection.DS';
import { BasketSeclectSectionOV as BasketSelectSectionOV_GB } from './OV/GB/BasketSeclectSection.OV';
import { BasketSelectSectionStyled } from './BasketSeclectSectionStyled';
import { SC } from '../../../styles/theme';

export type BasketSelectSectionProps = SC & {
    leftSectionTitle: string;
    leftSectionDescription: string;
    rightSectionTitle: string;
    rightSectionDescription: string;
    leftSelected: boolean;
    rightSelected: boolean;
    onClick: (value: string) => void;
    leftValue?: string;
    rightValue?: string;
    rightDetail?: {
        image: string;
        title: string;
        description: string;
        price: string;
        label: string;
    };
};

const BasketSelectSection = (props: BasketSelectSectionProps) => {
    if (BRAND === 'AC') return <BasketSeclectSectionAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? <BasketSelectSectionOV_GB {...props} /> : <BasketSeclectSectionOV {...props} />;
    if (BRAND === 'AP') return <BasketSeclectSectionAP {...props} />;
    if (BRAND === 'DS') return <BasketSeclectSectionDS {...props} />;
    return <BasketSelectSectionStyled {...props} />;
};

export default BasketSelectSection;
